import React, { useContext, useEffect } from 'react';
import { SelectedAddress, MapIFrameContext } from '../App';
import { GoToMessage, MapIframe, MapMessageType } from '../services/MapIframe';
import AddressSearch from './elements/AddressSearch';
import Button from './elements/Button';
import { AppView } from './RootStep';
import Location from './elements/Location';
import demoAddresses from '../data/demo_addresses.json';
import { geocodeByAddress } from 'react-google-places-autocomplete';

interface StartStepProps {
    setAppView: React.Dispatch<AppView>,
    address: SelectedAddress | null,
    setAddress: React.Dispatch<SelectedAddress | null>
}

function StartStep({ setAppView, address, setAddress }: StartStepProps) {

    const mapContext = useContext(MapIFrameContext);
    const location = address ? <div className="my-8 px-10"><Location label={address.label}></Location></div> : <></>;

    useEffect(() => {
        goToOnMap(mapContext, address);
    }, [address, mapContext]);

    const handleConfirmClick = () => {
        setAddress(address);
        setAppView(AppView.ROOF_OVER_VIEW);
    };

    const handleAddressSelect = (address:string) => {

        geocodeByAddress(address)
            .then(results => {

                if (!results || results.length === 0) {
                    return;
                }

                let first = results[0];

                setAddress({
                    label: address,
                    lat: first.geometry.location.lat(),
                    lng: first.geometry.location.lng(),
                });

            });
    }

    return <div className="py-16">
        <div className="mx-auto px-8 text-center min-h-[340px]">
            <h2 className="text-base font-semibold leading-7 text-cyan-600">THOR DEMO</h2>
            <p className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
                Enter your address
            </p>
            <p className="mt-8 text-lg leading-6 text-gray-500">
                This is a demo application that showcases how to obtain roof measurements from a map.
            </p>
            {demoAddresses.title && demoAddresses.title.trim() !== '' &&
                <p className="mt-4 leading-6 text-gray-500">
                    {demoAddresses.title}
                </p>}
            {demoAddresses?.addresses?.length > 0 &&
                <div className="mt-6 text-sm leading-6 text-gray-500">
                    Here are some example addresses:
                    <ul className={'text-sm mt-1 mb-8'}>
                        {
                            demoAddresses.addresses.map((address: string, index: number) => (
                                <li key={index} >
                                    <button type="button"
                                            onClick={() => handleAddressSelect(address)}
                                            className="font-medium py-0.5 text-cyan-600 hover:text-cyan-500">
                                        {address}
                                    </button>
                                </li>
                            ))
                        }
                    </ul>
                </div>
            }
            {location}
        </div>
        <div className="px-10">
            <AddressSearch setValue={setAddress}></AddressSearch>
            <div className="text-center mt-5">
                <Button onClick={handleConfirmClick} text="Confirm" full={true} disabled={!address}></Button>
            </div>
        </div>
    </div>;
}

function goToOnMap(mapContext: React.RefObject<HTMLIFrameElement> | null, address: SelectedAddress | null) {

    if (!mapContext || !address) {
        return;
    }

    MapIframe.post(mapContext, {
        lat: address?.lat,
        lng: address?.lng,
        closest: true,
        type: MapMessageType.GO_TO,
    } as GoToMessage);

}

export default StartStep;